import { Component, inject, signal, viewChild } from '@angular/core';
import { DiceColor } from '../../services/dice-service.service';
import { ExpressionService } from '../../services/expression-service.service';
import { RidDiceSlot } from '../rid-dice-slot/rid-dice-slot';
import { RidDice } from '../rid-dice/rid-dice';

@Component({
  selector: 'rid-expression-overlay',
  imports: [RidDiceSlot],
  templateUrl: './rid-expression-overlay.html',
  host: {
    class: 'block pointer-events-none absolute inset-0 overflow-hidden',
  },
})
export class RidExpressionOverlay {
  protected readonly $expressionService = inject(ExpressionService);

  readonly centerDice = viewChild<RidDice>('centerDice');
  dice = signal<{ faces: string[] | undefined; color: DiceColor } | undefined>(undefined);

  async toggleExpression(whomst: 'TUTOR' | 'CLIENT') {
    const current = whomst === 'TUTOR' ? this.$expressionService.tutorExpression() : this.$expressionService.clientExpression();
    if (current) {
      this.$expressionService.clearExpression(whomst);
    } else {
      await this.$expressionService.choseExpression(
        [
          '/expressions/alien.png',
          '/expressions/angry.png',
          '/expressions/bored.png',
          '/expressions/crying.png',
          '/expressions/laughing.png',
          '/expressions/monster.png',
        ],
        whomst,
      );
    }
  }
}
